import React from 'react';
import { Button } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/images/logo2.png';


const StyledAppBar = styled(AppBar)`
  background-color: #F41C2A;
  padding: 25px 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`;

const LogoTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const LogoImage = styled.img`
  height: 50px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const StyledButton = styled(Button)`
  color: white;
`;

const Header = () => {
  return (
    <StyledAppBar position="static">
      <LogoTitleContainer>
        <LogoImage src={logo} alt="Anomazle Logo" />
        <div>
          <Typography variant="h4">Anomazle</Typography>
          <Typography variant="subtitle1">
            Image Scrambling Puzzle Game
          </Typography>
        </div>
      </LogoTitleContainer>
      <div>
        <StyledLink to="/">
          <StyledButton>New Puzzle</StyledButton>
        </StyledLink>
      </div>
    </StyledAppBar>
  );
};

export default Header;
